"use strict";

require("core-js/modules/es.object.assign");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindComponent = bindComponent;
exports.createRegistryEntry = createRegistryEntry;

var _util = require("./util");

/**
 * Binds a component to the DOM
 * @param {HTMLElement} DOMElement
 * @param {Component} Component
 */
function bindComponent(entry, loaderInstance) {
  var instance = new entry.Component(entry.element, entry.options, loaderInstance); // eslint-disable-next-line no-param-reassign

  entry.element.component = instance;
  return Object.assign(entry, {
    instance: instance,
    loaderInstance: loaderInstance,
    loaded: true
  });
}

function createRegistryEntry(element, Component, options) {
  return {
    id: (0, _util.id)(),
    loaded: false,
    element: element,
    Component: Component,
    options: options
  };
}
//# sourceMappingURL=registry.js.map